import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pdf-findbar-options-one-container',
  templateUrl: './pdf-findbar-options-one-container.component.html',
  styleUrls: ['./pdf-findbar-options-one-container.component.css']
})
export class PdfFindbarOptionsOneContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
